<!-- Templete  -->
<template> 
    <!-- <draggable v-bind="dragOptions" :emptyInsertThreshold="500"  :disabled="!enabled" class="list-group" ghost-class="ghost"   @start="dragging = true" @end="dragging = false"> -->
    <div v-loading.fullscreen.lock="fullscreenLoading">
    <transition-group type="transition" :name="!drag ? 'flip-list' : null">
    </transition-group> 
    <div class="infinite-list-wrapper AllNewsTabInfiniteWrapper" style="overflow:auto">
      <ul
        class="list"
        v-infinite-scroll="load"
        infinite-scroll-disabled="enabled">
        <li class="listItem" v-for="(article,i) in articleList" v-bind:key="i">
          <!-- <NewsTabArticleComponent  v-for="article in filterData(articleList,i)"
            v-bind:key="article.article_no"  v-bind:articleId="article.article_id" 
            v-bind:articleTitle="article.article_title" 
            v-bind:note="article.note"
            v-bind:articleCategory="article.media_name" 
            v-bind:articleDate="article.issue_date" 
            v-bind:articlePages="article.issue_type" 
            v-bind:articleComment="article.article_comment"
            v-bind:articleNo="article.article_no"
            v-bind:articleEdition="article.articleEdition"
            v-bind:frame_no="article.frame_no"
            v-bind:data_section="article.data_section"
            v-bind:head_no="article.head_no"
            v-bind:trace="article.trace"
            v-bind:articleImage="article.articleImage"
            v-bind:articlePdf="article.no_image_flag"
            v-bind:articleText="article.no_text_flag"
            v-bind:articleSearchWord="article.search_word"
            v-bind:articleImagecount="article.image_count" 
            v-bind:articledataSection="article.data_section"
            v-bind:articleToolTipImage="article.McTooltipImage"
            v-bind:articlecharCount="article.char_count" /> -->

            <el-container>
              <div class="articleDiv" id="articleParentDiv">
                <el-row>
                  <el-header class="header-article">
                    <el-row class="articleRow">
                      <div class="articleLabel" v-if="article.no_image_flag == true && csv_download_flag == false">
                        <span class="AllNewsArticleCheckboxlabelText" tabindex="1">{{article.article_no}}</span>
                      </div>
                      <div class="articleLabel" v-else>
                        <el-checkbox class="checkbox-list" name="type" :label="article.article_no" @change="handleSelectionChange($event,article)"></el-checkbox>
                      </div>
                      <div v-if="article.data_section == 1">
                        <span class="article_top NewsTabArticleTitleText" v-if="mc_pdf_view_flag == false || article.no_image_flag == true">{{ article.article_title }}</span>
                        <span class="article-top NewsTabArticleTitleText" tabindex="2" @click="sendToErrorDisplay(article)" v-else>{{ article.article_title }}</span>
                      </div>
                      <div v-if="article.data_section == 2">
                        <span class="article_top NewsTabArticleTitleText" v-if="sc_pdf_view_flag == false || article.no_image_flag == true">{{ article.article_title }}</span>
                        <span class="article-top NewsTabArticleTitleText" tabindex="2" @click="sendToErrorDisplay(article)" v-else>{{ article.article_title }}</span>
                      </div>
                    </el-row>
                  </el-header>
                </el-row>
                <el-row>
                  <el-main>
                    <div class="commentRow">
                      <ul class="logoArtInfo">
                        <li class="article-first-child" v-if="article.data_section == 1">
                          <div class="article-img">
                            <img src="../../assets/image/logo-new.png" alt="LOGO" />
                          </div>
                        </li>
                        <li class="article-first-child" v-else-if="article.data_section == 2">
                          <div class="article-img">
                            <img src="../../assets/image/Nikkie-logo-web.svg" alt="LOGO" />
                          </div>
                        </li>
                        <li class="article-second-child">
                          <div class="article-list NewsTabArticleList">
                            <ul class="articleSpec">
                              <li v-if="article.media_name != ''">
                                <span class="articleSpan">{{ article.media_name }}</span>
                              </li>
                              <li v-if="article.issue_date != ''">
                                <span class="articleSpan">{{ article.issue_date }}</span>
                              </li>
                              <li v-if="article.issue_type != ''">
                                <span class="articleSpan">{{ article.issue_type }}</span>
                              </li>
                              <li v-if="article.search_word != ' ' && article.search_word != ''">
                                <span class="articleSpan">{{ article.search_word }}</span>
                              </li>
                            </ul>
                          </div>
                        </li>
                        <li class="article-third-child">
                          <div class="article-right">
                            <ul class="iconUl" v-if="article.data_section == 1">
                              <li v-if="mc_pdf_view_flag == false || article.no_image_flag == true">
                                <div class="ico_pdf_Disable" tabindex="0"></div>
                              </li>
                              <li v-else>
                                <el-tooltip placement="top-start" effect="dark">
                                  <!-- 2021/02/23 #10026 START-->
                                  <!--<el-carousel height="267px" style="width: 200px" class="tooltipInsideCarousel" :autoplay="true" slot="content">-->
                                  <el-carousel height="267px" style="width: 200px" class="tooltipInsideCarousel" :autoplay="true" slot="content" :arrow="article.McTooltipImage.length==1?'never':'hover'">
                                    <!-- 2021/02/23 #10026 END-->
                                    <el-carousel-item :setActiveItem="item" v-for="item in article.McTooltipImage" :key="item">
                                      <div style="width: 200px; height: 267px">
                                      <img :src="item" alt="ArticleSnap" @error="replaceByDefault" class="sliderImage" />
                                      </div>
                                    </el-carousel-item>
                                  </el-carousel>
                                  <div class="tooltip-image custom-arrow"></div>
                                  <div @click="sendToErrorDisplay(article)" class="ico_pdf_upSmall AllNewsico_pdf_upSmall" tabindex="0"></div>
                                </el-tooltip>
                              </li>
                              <li>
                                <div @click="goToThumbnailDisplayScreen(article)" class="ico_article_details_upSmall AllNewsico_article_details_upSmall" tabindex="0"></div>
                              </li>
                              <li v-if="mc_text_view_flag == false || article.no_text_flag == true">
                                <div class="ico_text_Disable" tabindex="0"></div>
                              </li>
                              <li v-else>
                                <div class="ico_text_upSmall AllNewsico_text_upSmall" @click="getPdfPrintScreen(article)" tabindex="0"></div>
                              </li>
                              <li v-if="mc_pdf_print_flag == false || article.no_image_flag == true">
                                <div class="ico_print_Disable" tabindex="0"></div>
                              </li>
                              <li v-else>
                                <div class="ico_print_upSmall AllNewsico_print_upSmall" @click="pdfPrint(article)" tabindex="0"></div>
                              </li>
                            </ul>
                            <ul class="iconUl" v-else-if="article.data_section == 2">
                              <li v-if="sc_pdf_view_flag == false || article.no_image_flag == true">
                                <div class="ico_pdf_Disable" tabindex="0"></div>
                              </li>
                              <li v-else>
                                <el-tooltip placement="top-start" effect="dark">
                                  <!-- 2021/02/23 #10026 START-->
                                  <!--<el-carousel height="267px" style="width: 200px" class="tooltipInsideCarousel" :autoplay="true" slot="content">-->
                                  <el-carousel height="267px" style="width: 200px" class="tooltipInsideCarousel" :autoplay="true" slot="content" :arrow="article.McTooltipImage.length==1?'never':'hover'">
                                    <!-- 2021/02/23 #10026 END-->
                                    <el-carousel-item :setActiveItem="item" v-for="item in article.McTooltipImage" :key="item">
                                      <div style="width: 200px; height: 267px">
                                      <img :src="item" alt="ArticleSnap" @error="replaceByDefault" class="sliderImage" />
                                      </div>
                                    </el-carousel-item>
                                  </el-carousel>
                                  <div class="tooltip-image custom-arrow"></div>
                                  <div @click="sendToErrorDisplay(article)" class="ico_pdf_upSmall AllNewsico_pdf_upSmall" tabindex="0"></div>
                                </el-tooltip>
                              </li>
                              <li>
                                <div class="ico_article_details_Disable" tabindex="0"></div>
                              </li>
                              <li v-if="sc_text_view_flag == false || article.no_text_flag == true">
                                <div class="ico_text_Disable" tabindex="0"></div>
                              </li>
                              <li v-else>
                                  <div class="ico_text_upSmall AllNewsico_text_upSmall" @click="goToThumbnailDisplayScreen(article)" tabindex="0"></div>
                              </li>
                              <li v-if="sc_pdf_print_flag == false || article.no_image_flag == true">
                                <div class="ico_print_Disable" tabindex="0"></div>
                              </li>
                              <li v-else>
                                <div class="ico_print_upSmall AllNewsico_print_upSmall" @click="pdfPrint(article)" tabindex="0"></div>
                              </li>
                            </ul>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </el-main>
                </el-row>
                <el-divider class="article-main-divider"></el-divider>
                <el-footer>
                  <div class="ariticle-bottom">
                    <ul>
                      <li v-if="article.article_comment != ''&& article.article_comment != null">
                        <div class="message ico_comment_upSmall AllNewsTabico_comment_upSmall"></div>
                      </li>
                      <li>
                        <div class="message-text NewsTabArticleMessageText" v-html="article.article_comment"></div>
                      </li>
                    </ul>
                  </div>
                </el-footer>
                <el-divider class="article-footer-divider"></el-divider>
              </div>
            </el-container>
        </li>
      </ul>
      <p v-if="this.getIsTopPageInitialLoading || loading" class="centeralign_css">表示中...( {{ this.articleList.length + 1 }}件 ～ {{ this.articleList.length + this.getMaxArticleCountPerPage}}件 )</p>
      <!-- 2020/11/26  BT08460_EXTERNAL-1812  START  -->
      <!-- <p v-if="this.getIsTopPageInitialLoading == false && IsNoMore" class="centeralign_css">レコードがありません</p>  -->
      <p v-if="this.getIsTopPageInitialLoading == false && IsNoMore" class="centeralign_css">レコードの最後です</p>
      <!-- 2020/11/26  BT08460_EXTERNAL-1812  END  -->
      <p v-if="this.getIsTopPageInitialLoading == false && (defaultLoading)" class="centeralign_css">ヒット結果は0件です</p> 
    </div> 
    </div>
    <!-- </draggable> -->
</template>

<!-- Script  -->
<script>
// import draggable from 'vuedraggable';
// import NewsTabArticleComponent from './NewsTabArticleComponent.vue';
let newArr = [];
const articleValue = {};
import error_image from "../../assets/image/errorThumbnail@3_200x200.png";
import { mapGetters } from "vuex";
import $ from "jquery";
import Vue from "vue";
export default {
    name: "simple",
    display: "Transitions",
    order: 3,
    props: {
      drag: Boolean,
      articleList: Array
    },
    components: {
      // draggable,
      // NewsTabArticleComponent,	
    },
  data() {
    return {
      count: 10,
      loading: false,
      IsNoMore:false,
      enabled: false,
      dragging: false,
      userId: '',
      contractId: '',
      theme_browsing: '',
      defaultLoading: false,
      mc_pdf_view_flag: '',
      mc_pdf_print_flag: '',
      mc_text_view_flag: '',
      mc_text_print_flag: '',
      sc_pdf_view_flag: '',
      sc_pdf_print_flag: '',
      sc_text_view_flag: '',
      sc_text_print_flag: '',
      contract_code: '',
      session_id: '',
      user_group_name: '',
      csv_download_flag: false,
      fullscreenLoading: false
    };
  },
  methods: {
    load() {
      this.noMore();
      if (this.loading == false)
      {
        // If already loading it will not run.
        // TOOD: if we retirve all article for the given 
        if(this.getThemeNewsCount == 0 || this.articleList.length >= this.getThemeNewsCount)
        {
          this.count = this.getMaxArticleCountPerPage;
        }
        else
        {
          // this.loading = true;
          this.setLoading(true);
          if(this.count > this.getThemeNewsCount)
          {
            // if the next retriving count is greater then total count, then resettting to max.
            this.count = this.getThemeNewsCount;
            // this.loading = false;
            this.setLoading(false,"second if");
          }
          else
          {
            this.count += this.getMaxArticleCountPerPage; // change to static.
            var themeValue = this.getSelectedTheme[0].value
            var theme_id = this.getSelectedTheme[0].id
            var startNumCount = this.articleList.length + 1

            var inputParam;
            
            if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == false)
            {
              
              if(themeValue == "Theme")
              {
                inputParam = {
                  contract_id: this.contractId,
                  process_date_start: this.getDefaultThemeStartDate,
                  process_date_end: this.getDefaultThemeEndDate,
                  sort_date: this.getScrollingDate,
                  sort_title: this.getScrollingTitle,
                  start_num: startNumCount,
                  load_num: this.getMaxArticleCountPerPage,
                  theme_id: theme_id
                };
              }
              else if(themeValue == "Theme Group")
              {
                inputParam = {
                  contract_id: this.contractId,
                  process_date_start: this.getDefaultThemeStartDate,
                  process_date_end: this.getDefaultThemeEndDate,
                  sort_date: this.getScrollingDate,
                  sort_title: this.getScrollingTitle,
                  start_num: startNumCount,
                  load_num: this.getMaxArticleCountPerPage,
                  theme_group_id: theme_id
                };
              }
              else if(themeValue == "Topics")
              {
                inputParam = {
                  contract_id: this.contractId,
                  process_date_start: this.getDefaultThemeStartDate,
                  process_date_end: this.getDefaultThemeEndDate,
                  sort_date: this.getScrollingDate,
                  sort_title: this.getScrollingTitle,
                  start_num: startNumCount,
                  load_num: this.getMaxArticleCountPerPage,
                  topics_id: theme_id
                };
              }
              else
              {
                //no action needed
              }

              var existingArticleDetails = [];

              existingArticleDetails = [...existingArticleDetails, inputParam, this.articleList];

              Vue.prototype.$session.set('InputParameterFor0006',inputParam);
              Vue.prototype.$session.set('CurrentAID',"0005");

              this.$store.dispatch('communication/getNewspaperArticles', existingArticleDetails)
              .then(() => {
                setTimeout(() => {
                  this.setLoading(false);
                }, 500);
              }).catch(()=>{
                setTimeout(() => {
                  this.setLoading(false);
                }, 500);
              });
            }
            else if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == true)
            {
              
              inputParam = {
                contract_id: this.contractId,
                process_date_start: this.getDefaultThemeStartDate,
                process_date_end: this.getDefaultThemeEndDate,
                sort_date: this.getScrollingDate,
                sort_title: this.getScrollingTitle,
                start_num: startNumCount,
                load_num: this.getMaxArticleCountPerPage
              };

              var existingTodayArticleDetails = [];

              existingTodayArticleDetails = [...existingTodayArticleDetails, inputParam, this.articleList];

              Vue.prototype.$session.set('InputParameterFor0006',inputParam);
              Vue.prototype.$session.set('CurrentAID',"0005");

              this.$store.dispatch('communication/getNewspaperArticles', existingTodayArticleDetails)
              .then(() => {
                setTimeout(() => {
                  this.setLoading(false);
                }, 500);
              }).catch(()=>{
                setTimeout(() => {
                  this.setLoading(false);
                }, 500);
              });
            }
            else if(this.getSearchConditionKey == 1)
            {
              if(this.getSearchValue != '')
              {
                inputParam ={
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 1,
                  display_id: 'SID0002',
                  process_date_from:this.getSearchStartDate,
                  process_date_to:this.getSearchEndDate,
                  theme_browsing: this.theme_browsing,
                  search_title: this.getSearchValue,
                  sort_date: this.getScrollingDate,
                  sort_title: this.getScrollingTitle,
                  start_num:startNumCount,
                  load_num:this.getMaxArticleCountPerPage
                }
              }
              else if(this.getKeywordValue != '')
              {
                if(this.getMediaValue != '')
                {
                  inputParam ={
                    contract_id: this.contractId,
                    user_id: this.userId,
                    contract_kbn: 1,
                    display_id: 'SID0002',
                    process_date_from:this.getSearchStartDate,
                    process_date_to:this.getSearchEndDate,
                    theme_browsing: this.theme_browsing,
                    key_word: this.getKeywordValue,
                    media_name: this.getMediaValue,
                    sort_date: this.getScrollingDate,
                    sort_title: this.getScrollingTitle,
                    start_num:startNumCount,
                    load_num:this.getMaxArticleCountPerPage
                  }
                }
                else
                {
                  inputParam ={
                    contract_id: this.contractId,
                    user_id: this.userId,
                    contract_kbn: 1,
                    display_id: 'SID0002',
                    process_date_from:this.getSearchStartDate,
                    process_date_to:this.getSearchEndDate,
                    theme_browsing: this.theme_browsing,
                    key_word: this.getKeywordValue,
                    sort_date: this.getScrollingDate,
                    sort_title: this.getScrollingTitle,
                    start_num:startNumCount,
                    load_num:this.getMaxArticleCountPerPage
                  }
                }
              }
              else
              {
                if(this.getMediaValue != '')
                {
                  inputParam ={
                    contract_id: this.contractId,
                    user_id: this.userId,
                    contract_kbn: 1,
                    display_id: 'SID0002',
                    process_date_from:this.getSearchStartDate,
                    process_date_to:this.getSearchEndDate,
                    theme_browsing: this.theme_browsing,
                    media_name: this.getMediaValue,
                    sort_date: this.getScrollingDate,
                    sort_title: this.getScrollingTitle,
                    start_num:startNumCount,
                    load_num:this.getMaxArticleCountPerPage
                  }
                }
                else
                {
                  inputParam ={
                    contract_id: this.contractId,
                    user_id: this.userId,
                    contract_kbn: 1,
                    display_id: 'SID0002',
                    process_date_from:this.getSearchStartDate,
                    process_date_to:this.getSearchEndDate,
                    theme_browsing: this.theme_browsing,
                    sort_date: this.getScrollingDate,
                    sort_title: this.getScrollingTitle,
                    start_num:startNumCount,
                    load_num:this.getMaxArticleCountPerPage
                  }
                }
              }

              var existingSearchArticle = [];

              existingSearchArticle = [...existingSearchArticle, inputParam, this.articleList];
              //Api call for sorting the news article(AID0071)
              this.$store.dispatch('communication/getNewsArticleUsingSorting', existingSearchArticle)
              .then(() => {
                this.setLoading(false);
              }).catch(()=>{
                this.setLoading(false);
              });
            }
            else if(this.getSearchConditionKey == 2)
            {
              if(this.getKeywordValue != '')
              {
                inputParam ={
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 1,
                  display_id: 'SID0002',
                  process_date_from:this.getSearchStartDate,
                  process_date_to:this.getSearchEndDate,
                  theme_browsing: this.theme_browsing,
                  key_word: this.getKeywordValue,
                  sort_date: this.getScrollingDate,
                  sort_title: this.getScrollingTitle,
                  start_num:startNumCount,
                  load_num:this.getMaxArticleCountPerPage
                }
              }
              else
              {
                inputParam ={
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 1,
                  display_id: 'SID0002',
                  process_date_from:this.getSearchStartDate,
                  process_date_to:this.getSearchEndDate,
                  theme_browsing: this.theme_browsing,
                  sort_date: this.getScrollingDate,
                  sort_title: this.getScrollingTitle,
                  start_num:startNumCount,
                  load_num:this.getMaxArticleCountPerPage
                }
              }

              var existingSearchKeywordArticle = [];

              existingSearchKeywordArticle = [...existingSearchKeywordArticle, inputParam, this.articleList];
              //Api call for sorting the news article(AID0071)
              this.$store.dispatch('communication/getNewsArticleUsingSorting', existingSearchKeywordArticle)
              .then(() => {
                this.setLoading(false);
              }).catch(()=>{
                this.setLoading(false);
              });
            }
            else
            {
              //no action needed
            }
            
          }
        }
        
      }
      this.noMore();
    },
    filterData:function(articleData,i){
      return articleData.filter(function(article){
        return article.article_no == i;
      })
    },
    setLoading(isLoading){
      this.loading = isLoading;
    },
    noMore () {
      if(this.getThemeNewsCount == 0)
      {
        this.IsNoMore = false
        this.defaultLoading = true
      }
      else
      {
        this.IsNoMore = this.getThemeNewsCount <= this.articleList.length;
        this.defaultLoading = false
      }
      if(this.IsNoMore == true || this.NoDefaultRecord == true){
        // if noMore is true, then we are setting this.loading to false.
        this.setLoading(false,'NoMore')
      }
    }, 
    //method for set static image for tooltip when error occurs
    replaceByDefault(event) {
      event.target.src = error_image;
    },
    //method for get the selected article count and set the selected article for batch process
    handleSelectionChange(val,article){
      this.$LogButtonEvent("NewsTabArticleComponent","ChangeSelection");
      this.$LogMethodIN("NewsTabArticleComponent","handleSelectionChange");    
      articleValue.value = val;
      newArr = this.getArticleDetails
      var checkboxValue = this.getNewsFirstTabCheckboxValue
      if(articleValue.value == true){
        ++checkboxValue;
        newArr.push(article.article_no);
      }else{
        --checkboxValue;
        Array.prototype.remove = function() {
            var what, a = arguments, L = a.length, ax;
            while (L && this.length) {
                what = a[--L];
                while ((ax = this.indexOf(what)) !== -1) {
                    this.splice(ax, 1);
                }
            }
            return this;
        };
        newArr.remove(article.article_no);
      }
      this.$store.commit("situation/setNewsFirstTabCheckboxValue", checkboxValue);
      this.$store.commit('situation/setArticleDetails', newArr);
      this.$LogMethodOut("NewsTabArticleComponent","handleSelectionChange");
    },
    //method for redirecting to pdf display(SID0004) screen
    sendToErrorDisplay(article){
      this.$LogButtonEvent("NewsTabArticleComponent","Showpdf");
      this.$LogMethodIN("NewsTabArticleComponent","sendToErrorDisplay");   
      var pdfValues = {
        pdf_flag: 1,
        article_info:[
          {
            article_id: article.article_id,
            data_section: article.data_section
          }
        ],
        user_id:this.userId,
        contract_code:this.contract_code,
        theme_browsing:this.theme_browsing,
        display_id:"SID0002",
        is_mail:false
      };

      var pdfSuccessValues = {
        data_info:[
          {
            contract_id: this.contractId,
            data_section: article.data_section,
            user_id: this.userId,
            request_div:1,
            article_id: article.article_id,
            session_id: this.session_id,
            user_group_name: this.user_group_name,
            theme_id: this.getThemeIdForPdfSuccess,
            theme_group_id: this.getThemeGroupIdForPdfSuccess,
            topics_id: this.getTopicsIdForPdfSuccess
          }
        ]
      }

      var pdfCombinedArray = [];

      pdfCombinedArray = [...pdfCombinedArray, pdfValues, pdfSuccessValues];
      if(this.getOut_Demand_Confirm_Message_Div_Flag)
      {
        this.$confirm(this.getDemandConfirmPdfMessage,"確認",
          {
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: "キャンセル",
            beforeClose: (action, instance, done) => {
              if(action === "confirm"){
                /*******BT08460_EXTERNAL-1539 issue fix*******/
                this.$session.set('pdfCombinedArray', pdfCombinedArray);
                let routeData = this.$router.resolve({name: '0001-001'}); 
                window.open(routeData.href, '_blank');
                /*this.fullscreenLoading = true;
                this.$store.dispatch('communication0004/getPdfDisplay', pdfCombinedArray).then(() => {
                  this.fullscreenLoading = false;
                }).catch(() => {
                  this.fullscreenLoading = false;
                })*/
                /*******BT08460_EXTERNAL-1539 issue fix*******/
                done();
              }else{
                done();
              }
            }
          }
        );
      }
      else
      {
        /*******BT08460_EXTERNAL-1539 issue fix*******/
        this.$session.set('pdfCombinedArray', pdfCombinedArray);
        let routeData = this.$router.resolve({name: '0001-001'}); 
        window.open(routeData.href, '_blank');
        /*this.fullscreenLoading = true;
        this.$store.dispatch('communication0004/getPdfDisplay', pdfCombinedArray).then(() => {
          this.fullscreenLoading = false;
        }).catch(() => {
          this.fullscreenLoading = false;
        })*/
        /*******BT08460_EXTERNAL-1539 issue fix*******/
      }
      this.$LogMethodOut("NewsTabArticleComponent","sendToErrorDisplay");
    },
    //methos for redirecting to text display(SID0008) sreen
    getPdfPrintScreen(article){
      this.$LogButtonEvent("NewsTabArticleComponent","Showpdfprintscreen");
      this.$LogMethodIN("NewsTabArticleComponent","getPdfPrintScreen");      
      var articleDetails = {
        articleId: article.article_id,
        data_section: article.data_section,        
        printOption: true,
        is_mail:false,
        display_id:"SID0002"
      };
      if(this.getOut_Demand_Confirm_Message_Div_Flag)
      {
        this.$confirm(this.getDemandConfirmTextMessage,"確認",
          {
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: "キャンセル",
            beforeClose: (action, instance, done) => {
              if(action === "confirm")
              {
                let routeData = this.$router.resolve({name: '0008', query: articleDetails}); 
                window.open(routeData.href, '_blank');
                done();
              }
              else
              {
                done();
              }
            }
          }
        );
      }
      else
      {
        let routeData = this.$router.resolve({name: '0008', query: articleDetails}); 
        window.open(routeData.href, '_blank');
      }
      this.$LogMethodOut("NewsTabArticleComponent","getPdfPrintScreen");
    },
    //methos for redirecting to print display screen
    pdfPrint(article){
      this.$LogButtonEvent("NewsTabArticleComponent","PrintPdf");
      this.$LogMethodIN("NewsTabArticleComponent","pdfPrint");  
      var pdfValues = {
        pdf_flag:2,
        article_info:[
            {
              article_id: article.article_id,
              data_section: article.data_section
            }
          ],
          user_id:this.userId,
          contract_code:this.contract_code,
          theme_browsing:this.theme_browsing,
          display_id:"SID0002"
      }
      
      var printSuccessValues = {
        data_info:[{
        contract_id: this.contractId,
        data_section: article.data_section,
        user_id: this.userId,
        read_count:1,
        request_div:2,
        article_id: article.article_id,
        session_id: this.session_id,
        user_group_name: this.user_group_name,
        theme_id: this.getThemeIdForPdfSuccess,
        theme_group_id: this.getThemeGroupIdForPdfSuccess,
        topics_id: this.getTopicsIdForPdfSuccess
        }]
      }

      var printCombinedArray = [];

      printCombinedArray = [...printCombinedArray, pdfValues, printSuccessValues];
      if(this.getOut_Demand_Confirm_Message_Div_Flag)
      {
        this.$confirm(this.getDemandConfirmPrintMessage,"確認",
          {
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: "キャンセル",
            beforeClose: (action, instance, done) => {
              if(action === "confirm")
              {
                this.fullscreenLoading = true;
                this.$store.dispatch('communication0004/getPdfPrint', printCombinedArray).then(() => {
                  this.fullscreenLoading = false;
                })
                .catch(() => {
                  this.fullscreenLoading = false;
                })
                done();
              }
              else
              {
                done();
              }
            }
          }
        );
      }
      else
      {
        this.fullscreenLoading = true;
        this.$store.dispatch('communication0004/getPdfPrint', printCombinedArray).then(() => {
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        })
      }
      this.$LogMethodOut("NewsTabArticleComponent","pdfPrint");

    },
    //methos for redirecting to thumnaildisplay(SID0006 For MC, SID0007 For SC) screen
    goToThumbnailDisplayScreen(article){
      this.$LogButtonEvent("NewsTabArticleComponent","DisplayThumbnail");
      this.$LogMethodIN("NewsTabArticleComponent","goToThumbnailDisplayScreen");
      var article_id = article.article_id;
      var data_section = article.data_section;
      this.$session.set('Article_Id', article_id);
      this.$session.set('CurrentRowNo', article.article_no - 1);
      this.$session.set('CurrentSID', "0002");
      if(data_section == 1)
      {
        let routeData = this.$router.resolve({name: '0006'}); 
        window.open(routeData.href, '_blank');
      }
      else if(data_section == 2)
      {
        let routeData = this.$router.resolve({name: '0007'}); 
        window.open(routeData.href, '_blank');
      }
      this.$LogMethodOut("NewsTabArticleComponent","goToThumbnailDisplayScreen");
    },
  },
  computed: {
    ...mapGetters("situation",[
                  "getSelectedTheme",
                  "getDefaultThemeStartDate",
                  "getDefaultThemeEndDate",
                  "getRefreshingArticles",
                  "getThemeNewsCount",
                  "getScrollingDate",
                  "getScrollingTitle",
                  "getIsTopPageInitialLoading",
                  "getMaxArticleCountPerPage",
                  "getSearchConditionKey",
                  "getSearchValue",
                  "getKeywordValue",
                  "getMediaValue",
                  "getSearchStartDate",
                  "getSearchEndDate",
                  "getTodayArticleFlag",
                  "getNewsFirstTabCheckboxValue",
                  "getArticleDetails",
                  "getThemeIdForPdfSuccess",
                  "getThemeGroupIdForPdfSuccess",
                  "getTopicsIdForPdfSuccess",
                  "getPopUpBlockerFlag"]),
    ...mapGetters("situation0001", ["getUserId",
                                  "getContractId",
                                  "getThemeBrowsing",
                                  "getContractCode",
                                  "getUserGroupName",
                                  "getMessageInfo",
                                  "getMC_Pdf_View_Flag",
                                  "getMC_Pdf_Print_Flag",
                                  "getMC_Text_View_Flag",
                                  "getMC_Text_Print_Flag",
                                  "getSC_Pdf_View_Flag",
                                  "getSC_Pdf_Print_Flag",
                                  "getSC_Text_View_Flag",
                                  "getSC_Text_Print_Flag",
                                  "getServiceLinkageInfo",
                                  "getDefault_Font_Size",
                                  "getOut_Demand_Confirm_Message_Div_Flag",
                                  "getDemandConfirmPdfMessage",
                                  "getDemandConfirmTextMessage",
                                  "getDemandConfirmPrintMessage"]),
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    
    disabled () {
      return this.loading || this.noMore()
    }
  },
  mounted(){
    //get the user id value from session
    this.userId = this.getUserId;

    //get the contract_id value from session
    this.contractId = this.getContractId;

    //get the theme_browsing value from session
    this.theme_browsing = this.getThemeBrowsing;

    //get the contract code value from session
    this.contract_code = this.getContractCode;

    //get the session id value from session
    this.session_id = Vue.prototype.$session.get('session-id');

    //get the user_group_name value from session
    this.user_group_name = this.getUserGroupName;

    this.mc_pdf_view_flag = this.getMC_Pdf_View_Flag;
    this.mc_pdf_print_flag = this.getMC_Pdf_Print_Flag;
    this.mc_text_view_flag = this.getMC_Text_View_Flag;
    this.mc_text_print_flag = this.getMC_Text_Print_Flag;

    this.sc_pdf_view_flag = this.getSC_Pdf_View_Flag;
    this.sc_pdf_print_flag = this.getSC_Pdf_Print_Flag;
    this.sc_text_view_flag = this.getSC_Text_View_Flag;
    this.sc_text_print_flag = this.getSC_Text_Print_Flag;

    //get the service linkage info value from the session
    var service_linkage = this.getServiceLinkageInfo;

    for(var l=0;l<service_linkage.length;l++)
    {
      if(service_linkage[l].data_section == 1)
      {
        this.csv_download_flag = service_linkage[l].csv_output_flag;
      }
      else
      {
        //no action needed
      }
    }
  },
  updated(){
    var font_size_flag = this.getDefault_Font_Size;
    if(font_size_flag == 0)
    {
      $(".article-img img").css({
        "width": "calc(80% * 0.8)",
        "height": "calc(22px * 0.8)",
      });
      $('.articleLabel').css({
        "width": "65px",
      });
      $('.select_custom').css({"width": "64px"});
      $('.commentRow ul').css('margin-left', '65px');
      $('.commentRow .logoArtInfo').css('min-height', '30px');
      $('.strip').addClass('smallStrip');
      $('.strip').removeClass('mediumStrip');
      $('.strip').removeClass('largeStrip');
      $('.el-menu--horizontal>.el-menu-item').css('height', '38px');
      $('.menuParent, .webMenuParent').css('height', '28px');
      $('.toolTipDiv span label').css('line-height', '30px');
      $('.year-arrow').css('line-height', '30px');
      $('.year-arrow').addClass('arrowSortSmall');
      $('.year-arrow').removeClass('arrowSortLarge');
      $('.articleLabel .el-checkbox__inner').addClass('ArticleSmall');
      $('.articleLabel .el-checkbox__inner').removeClass('ArticleLarge');
      $('.articleLabel .el-checkbox__label').css('font-size', 'calc(8pt * 0.8)');
      $(".toolTipDiv span label").css("font-size", "calc(8pt * 0.8)"); 
      $(".selectList").css("font-size", "calc(8pt * 0.8)"); 
      $(".articleLabel .el-checkbox__input, .articleLabel .el-checkbox__input .el-checkbox__inner").css({
        "width": "calc(14px * 0.8)",
        "height": "calc(14px * 0.8)",
      });
      $(".display-size > ul > li > span").css('font-size', 'calc(9.6pt * 0.8)');
      $("#newsFontSizeChange .el-checkbox__inner, #newsTabFontSizeChange .el-checkbox__inner, #webFontSizeChange .el-checkbox__inner, #webTabFontSizeChange .el-checkbox__inner ").addClass('smallCheck');
      $("#newsFontSizeChange .el-checkbox__inner, #newsTabFontSizeChange .el-checkbox__inner, #webFontSizeChange .el-checkbox__inner, #webTabFontSizeChange .el-checkbox__inner ").removeClass('largeCheck');
      $(".ico_comment_upSmall, .ico_sort_up, .ico_csv-output_up, .ico_print_up, .ico_pdf_upSmall, .ico_text_upSmall, .ico_print_upSmall, .checkList .el-checkbox__inner, .checkList").css({
        "width": "calc(22px * 0.8)",
        "height": "calc(22px * 0.8)",
      });
      // Disable icon style
      $(".ico_pdf_Disable, .ico_article_details_Disable, .ico_text_Disable, .ico_print_Disable").css({
        "width": "calc(22px * 0.8)",
        "height": "calc(22px * 0.8)",
      });
      $(".ico_article-details_up, .ico_article_details_upSmall").css({
        "width": "calc(22px * 0.8)",
        "height": "calc(22px * 0.8)",
      });
      $(".ico_batch-display_up").css({
        "width": "calc(16.57px * 0.8)",
        "height": "calc(22px * 0.8)",
      });
      $(".ico_another-tab_up").css({
        "width": "calc(22px * 0.8)",
        "height": "calc(22px * 0.8)",
      });
      $(".newsTitle, .webNewsTitle").css("font-size","calc(9.6pt * 0.8)");
      $(".display-size, .menuLable div, .message-text").css("font-size", "6.4pt");
      $(".article-top, .article_top, .article-top-disable ").css("font-size", "8.32pt");
      $(".article-list ul li").css("font-size", "6.4pt");
    }
    else if(font_size_flag == 1)
    {
      $(".article-img img").css({
        "width": "80%",
        "height": "22px",
      });
      $('.articleLabel').css({
        "width": "65px",
      });
      $('.select_custom').css({"width": "76px"});
      $('.commentRow ul').css('margin-left', '65px');
      $('.commentRow .logoArtInfo').css('min-height', '32px');
       $('.strip').removeClass('smallStrip');
       $('.strip').removeClass('largeStrip');
       $('.strip').addClass('mediumStrip');
      $('.year-arrow').removeClass('arrowSortSmall');
      $('.year-arrow').removeClass('arrowSortLarge');
      $('.el-menu--horizontal>.el-menu-item').css('height', '38px');
      $('.menuParent, .webMenuParent').css('height', '34px');
      $('.toolTipDiv span label').css('line-height', '36px');
      $('.year-arrow').css('line-height', '36px');
      $('.articleLabel .el-checkbox__inner').removeClass('ArticleSmall');
      $('.articleLabel .el-checkbox__inner').removeClass('ArticleLarge');
      $('.articleLabel .el-checkbox__label').css('font-size', '8pt');
      $(".toolTipDiv span label").css("font-size", "8pt"); 
      $(".selectList").css("font-size", "8pt"); 
       $(".articleLabel .el-checkbox__input, .articleLabel .el-checkbox__input .el-checkbox__inner").css({
        "width": "14px",
        "height": "14px",
      });
      $(".display-size > ul > li > span").css('font-size', '9.6pt');
      $("#newsFontSizeChange .el-checkbox__inner, #newsTabFontSizeChange .el-checkbox__inner, #webFontSizeChange .el-checkbox__inner, #webTabFontSizeChange .el-checkbox__inner").removeClass('largeCheck');
      $("#newsFontSizeChange .el-checkbox__inner, #newsTabFontSizeChange .el-checkbox__inner, #webFontSizeChange .el-checkbox__inner, #webTabFontSizeChange .el-checkbox__inner").removeClass('smallCheck');
      $(".ico_comment_upSmall, .ico_sort_up, .ico_csv-output_up, .ico_print_up, .ico_pdf_upSmall, .ico_text_upSmall, .ico_print_upSmall, .checkList .el-checkbox__inner, .checkList").css({
        "width": "22px",
        "height": "22px",
      });
      // Disable icon style
      $(".ico_pdf_Disable, .ico_article_details_Disable, .ico_text_Disable, .ico_print_Disable").css({
       "width": "22px",
        "height": "22px",
      });
      $(".ico_article-details_up, .ico_article_details_upSmall").css({
        "width": "22px",
        "height": "22px",
      });
      $(".ico_batch-display_up").css({
        "width": "16.57px",
        "height": "22px",
      });
      $(".ico_another-tab_up").css({
        "width": "22px",
        "height": "22px",
      });
      $(".newsTitle, .webNewsTitle").css("font-size", "9.6pt");
      $(".display-size, .menuLable div, .message-text, .DisplaySize").css("font-size", "8pt");
      $(".article-top, .article_top, .article-top-disable ").css("font-size", "10.4pt");
      $(".article-list ul li").css("font-size", "8pt");
    }
    else
    {
      $(".article-img img").css({
        "width": "calc(80% * 1.5)",
        "height": "calc(22px * 1.5)",
      }); 
      $('.articleLabel').css({
        "width": "85px",
        "display": "inline-table"
      });
      $('.select_custom').css({"width": "108px"});
      $('.ariticle-bottom ul').css('margin-left', '67px');
      $('.commentRow ul').css('margin-left', '85px');
      $('.commentRow .logoArtInfo').css('min-height', '38px');
      $('.strip').addClass('largeStrip');
      $('.strip').removeClass('mediumStrip');
      $('.strip').removeClass('smallStrip');
      $('.year-arrow').removeClass('arrowSortSmall');
      $('.year-arrow').addClass('arrowSortLarge');
      $('.el-menu--horizontal>.el-menu-item').css('height', '45px');
      $('.menuParent, .webMenuParent').css('height', '46px');
      $('.toolTipDiv span label').css('line-height', '47px');
      $('.year-arrow').css('line-height', '54px');
      $('.articleLabel .el-checkbox__inner').removeClass('ArticleSmall');
      $('.articleLabel .el-checkbox__inner').addClass('ArticleLarge');
      $('.articleLabel .el-checkbox__label').css('font-size', 'calc(8pt * 1.5)');
      $(".toolTipDiv span label").css("font-size", "calc(8pt * 1.5)"); 
      $(".selectList").css("font-size", "calc(8pt * 1.5)"); 
       $(".articleLabel .el-checkbox__input, .articleLabel .el-checkbox__input .el-checkbox__inner").css({
        "width": "calc(14px * 1.5)",
        "height": "calc(14px * 1.5)",
      });
      $(".display-size > ul > li > span").css('font-size', 'calc(9.6pt * 1.5)');
      $("#newsFontSizeChange .el-checkbox__inner, #newsTabFontSizeChange .el-checkbox__inner, #webFontSizeChange .el-checkbox__inner, #webTabFontSizeChange .el-checkbox__inner ").addClass('largeCheck');
      $("#newsFontSizeChange .el-checkbox__inner, #newsTabFontSizeChange .el-checkbox__inner, #webFontSizeChange .el-checkbox__inner, #webTabFontSizeChange .el-checkbox__inner").removeClass('smallCheck');
      $(".ico_comment_upSmall, .ico_sort_up, .ico_csv-output_up, .ico_print_up, .ico_pdf_upSmall, .ico_text_upSmall, .ico_print_upSmall, .checkList .el-checkbox__inner, .checkList").css({
        "width": "calc(22px * 1.5)",
        "height": "calc(22px * 1.5)",
      });
       // Disable icon style
      $(".ico_pdf_Disable, .ico_article_details_Disable, .ico_text_Disable, .ico_print_Disable").css({
        "width": "calc(22px * 1.5)",
        "height": "calc(22px * 1.5)",
      });
      $(".ico_article-details_up, .ico_article_details_upSmall").css({
        "width": "calc(22px * 1.5)",
        "height": "calc(22px * 1.5)",
      });
      $(".ico_batch-display_up").css({
        "width": "calc(16.57px * 1.5)",
        "height": "calc(22px * 1.5)",
      });
      $(".ico_another-tab_up").css({
        "width": "calc(22px * 1.5)",
        "height": "calc(22px * 1.5)",
      });
      $(".newsTitle, .webNewsTitle").css("font-size","calc(9.6pt * 1.5)");
      $(".display-size, .menuLable div, .message-text").css("font-size", "12pt");
      $(".article-top, .article_top, .article-top-disable ").css("font-size", "15.6pt");
      $(".article-list ul li").css("font-size", "12pt");
    }
  }
}
</script>
<style>
.flip-list-move {
  transition: transform 0.5s;
}

label {
  font-size: 8pt;
  padding-left: 6px;
}

.el-checkbox {
  margin-right: 0px !important;
}

.infinite-list-wrapper, .AllNewsTabInfiniteWrapper {
    max-height: 700px;
    text-align: left;
}
.infinite-list-wrapper .list {
    padding: 0;
    margin: 0;
    list-style: none;
    margin-bottom: 45px;
}

.infinite-list-wrapper .list-item {
    display: flex;
    align-items: left;
    justify-content: left;
    height: 100px;
}

.infinite-list-wrapper .list-item+.list-item {
    margin-top: 10px;
}

.centeralign_css {
  position: relative !important;
  bottom: 27px !important;
  right: 5px !important;            
  width: 100% !important;
  text-align: center !important;
}

.infinite-list-wrapper .listItem:nth-child(2n+2) {
  background-color: #f2f5f8;
}

.articleDiv {
  width: 100%;
}
.articleDiv .el-row {
  display: flex;
}
/* *************    hover focus svg icons        ************* */
.ico_pdf_upSmall, .AllNewsTabico_pdf_upSmall {
  background: url("../../assets/image/ico_pdf_up.svg") no-repeat;
  width: 22px;
  height: 22px;
}

.ico_pdf_upSmall, .AllNewsTabico_pdf_upSmall:hover {
  background: url("../../assets/image/ico_pdf_over.svg") no-repeat;
}

.ico_pdf_upSmall, .AllNewsTabico_pdf_upSmall:focus {
  background: url("../../assets/image/ico_pdf_down.svg") no-repeat;
  outline: none;
}

.ico_article_details_upSmall, .AllNewsTabico_article_details_upSmall {
  background: url("../../assets/image/ico_article-details_up.svg") no-repeat;
  width: 22px;
  height: 22px;
}

.ico_article_details_upSmall, .AllNewsTabico_article_details_upSmall:hover {
  background: url("../../assets/image/ico_article-details_over.svg") no-repeat;
}

.ico_article_details_upSmall, .AllNewsTabico_article_details_upSmall:focus {
  background: url("../../assets/image/ico_article-details_down.svg") no-repeat;
  outline: none;
}

.ico_text_upSmall, .AllNewsTabico_text_upSmall {
  background: url("../../assets/image/ico_text_up.svg") no-repeat;
  width: 22px;
  height: 22px;
}

.ico_text_upSmall, .AllNewsTabico_text_upSmall:hover {
  background: url("../../assets/image/ico_text_over.svg") no-repeat;
}
.ico_text_upSmall, .AllNewsTabico_text_upSmall:focus {
  background: url("../../assets/image/ico_text_down.svg") no-repeat;
  outline: none;
}

.ico_print_upSmall, .AllNewsTabico_print_upSmall {
  background: url("../../assets/image/ico_print_up.svg") no-repeat;
  width: 22px;
  height: 22px;
}

.ico_print_upSmall, .AllNewsTabico_print_upSmall:hover {
  background: url("../../assets/image/ico_print_over.svg") no-repeat;
}
.ico_print_upSmall, .AllNewsTabico_print_upSmall:focus {
  background: url("../../assets/image/ico_print_down.svg") no-repeat;
  outline: none;
}

.ico_comment_upSmall, .AllNewsTabico_comment_upSmall {
  background: url("../../assets/image/ico_comment_up.svg") no-repeat;
  width: 22px;
  height: 22px;
  position: relative;
  top: 5px;
}

.commentRow {
  min-height: 26px;
}

#anim > div > div > div > span > section:nth-child(2) > div {
  background-color: var(--grayBackground);
}

.article-img img {
  width: 80%;
  float: left;
  padding-top: 3px;
  height: 22px;
}

.checkbox-list {
  padding: 8px 0px 8px 7px;
}
.articleNews {
  float: left;
  width: 100%;
}
.articleLabel {
  float: left;
  width: 65px;
}
.articleLabel label:nth-child(2) {
  padding-left: 0px;
  line-height: 35px;
  color: var(--grayDark2);
}
.header-article {
  height: 45px !important;
  display: contents;
}

.el-main {
  overflow: hidden !important;
  padding: 0px !important;
}

.article-main-divider {
  margin: 0px !important;
  background: var(--grayLight2) !important;
}

.article-footer-divider {
  margin: 0px !important;
  background: #a2a4aa !important;
}

.article-top, .NewsTabArticleTitleText {
  font-size: 10.4pt;
  font-weight: bold;
  font-family: BIZ UDゴシック;
  padding-right: 0px;
  color: var(--link);
  cursor: pointer;
  display: block;
  margin-top: 9px;
  line-height: 22px;
}

.article-top:focus {
  color: var(--visited);
  outline: none;
}

.article-top:hover {
  color: #660099;
}

.article-middle {
  padding: 0px;
  margin: 0px auto;
  padding-left: 45px;
}

.el-footer {
  height: auto !important;
  padding-right: 0px;
}

.NewsTabArticleList ul {
  padding: 0px;
  margin: 6px auto;
}

.article-list ul li, .NewsTabArticleList ul li {
  list-style: inside;
  font-size: 8pt;
  padding-right: 8px;
  color: var(--grayDark);
  cursor: pointer;
  line-height: 1.1;
  cursor: default;
}

.article-right ul {
  padding: 0px;
  margin: 8px auto;
}

.article-right ul li {
  list-style: none;
  float: right;
  padding-left: 12px;
  color: #0097e0;
  padding-top: 5px;
  padding-bottom: 5px;
}

.article-right ul li img {
  width: 15px;
  margin-top: -1px;
}

.message {
  float: right;
  font-size: 20px;
  color: #0097e0;
  line-height: 28px;
  display: block;
  margin-right: 5px;
}

.message img {
  width: 24px;
  margin-left: 15px;
}

.message-text, .NewsTabArticleMessageText {
 font-size: 8pt;
  color: var(--grayDark);
  position: relative;
  word-break: break-all;
}

.NewsTabArticleMessageText ::v-deep h4 {
  margin: 0px !important;
}
.NewsTabArticleMessageText ::v-deep.ql-align-right {
  text-align: right;
  width: auto;
}
.NewsTabArticleMessageText ::v-deep.ql-align-left {
  text-align: left;
  width: auto;
}
.NewsTabArticleMessageText ::v-deep.ql-align-center {
  text-align: center;
  width: auto;
}
.tooltipInsideCarousel img {
    width: 100%;
    height: auto;
    max-width: fit-content;
    margin-top: auto;
    margin-bottom: auto;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    max-height: 100%;
    margin-left: auto;
    margin-right: auto;
    object-fit: contain;
}

.commentRow ul {
  padding: 0px;
  margin: 0px auto;
  margin-left: 65px;
  min-height: 26px;
}

.commentRow ul li {
  float: left;
}

.commentRow ul li:last-child {
  float: right;
}

.ariticle-bottom {
  display: flex;
}

.ariticle-bottom ul {
  list-style: none;
  margin: 0px;
  padding: 0px;
  display: flex;
  width: 100%;
  margin-left: 50px;
}

.ariticle-bottom ul li {
  float: left;
}

.ariticle-bottom ul li:nth-child(1) {
  float: left;
}

.ariticle-bottom ul li:nth-child(2) {
  float: left;
  width: 100%;
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #409EFF !important;
  border-color: #409EFF !important;
}

.list-first-div {
  width: 60px;
}

.list-first-div div {
  display: inline-block;
}

.NewsTabArticleList ul li:first-child {
  padding-left: 0px !important;
}

.articleSpec {
  display: inline-block !important;
  margin-left: 0px !important;
}

.articleSpec li {
  float: left !important;
  padding-top: 10px;
}

.iconUl {
  margin-left: 0px !important;
  float: right;
}

.article-first-child {
  width: 100px;
}

.article-second-child {
  width: calc(100% - 310px);
  margin-left: 20px;
}

.article-third-child {
  width: 175px;
  position: absolute;
  right: 0;
  top: -5px;
}

.article-right ul li:last-child {
  padding-right: 5px;
}

.article-right ul li:first-child {
  padding-left: 0px;
}

.articleSpec li .articleSpan {
  margin-left: -6px;
}

#articleParentDiv >>> .el-checkbox__label {
  font-size: 8pt;
}

/* Disable icon style */
.ico_pdf_Disable {
  background: url("../../assets/image/ico_pdf_up.svg") no-repeat;
  width: 22px;
  height: 22px;
  opacity: 0.2;
}

.ico_article_details_Disable {
  background: url("../../assets/image/ico_article-details_up.svg") no-repeat;
  width: 22px;
  height: 22px;
  opacity: 0.2;
}

.ico_text_Disable {
  background: url("../../assets/image/ico_text_up.svg") no-repeat;
  width: 22px;
  height: 22px;
  opacity: 0.2;
}

.ico_print_Disable {
  background: url("../../assets/image/ico_print_up.svg") no-repeat;
  width: 22px;
  height: 22px;
  opacity: 0.2;
}

.article-top-disable {
   font-size: 10.4pt;
  font-weight: bold;
  padding-right: 0px;
  color: #000;
  cursor: default;
  display: block;
  margin-top: 9px;
  line-height: 22px;
  margin-left: 8px;
  font-family: BIZ UDゴシック;
}

.article-top-disable:focus {
  outline: none;
}


.tooltipInsideCarousel >>> .el-carousel__indicator {
  display: none !important;
}

.tooltipInsideCarousel >>> .el-carousel__arrow--right  {
  right: 0px !important;
}

.tooltipInsideCarousel >>> .el-carousel__arrow--left  {
  left: 0px !important;
}

.tooltipInsideCarousel >>> .el-carousel__arrow  {
  height: 20px !important;
  width: 20px !important;
}

.AllNewsArticleCheckboxlabelText {
  font-size: 8pt;
  margin-top: 10px;
  margin-left: 20px;
  display: inline-block;
  padding-left: 10px;
  line-height: 19px;
}
.header-article .article_top {
  color: #000;
  cursor: default;
}
</style>
